//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/Expression.js";
import "../no/SelectBody.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddedPartName",1,0],[0,"AngleToleranceValue",1,0],[0,"BlankPosition",1,0],[1,"BlankProfile",0,"Section",0],[0,"BlankType",1,0],[0,"BottomBackPlateClearance",1,0],[0,"BottomPlateClearance",1,0],[1,"BoundaryFaces",0,"ScCollector",0],[0,"DesignOption",1,0],[0,"DiePlateClearance",1,0],[0,"ExtractWithoutHole",1,0],[1,"FormingInsertDelete",0,"Assemblies.SelectComponentList",0],[0,"FormingInsertPart",1,"TaggedObject",0],[1,"HeightValue",0,"Expression",0],[1,"LowerValue",0,"Expression",0],[0,"ParentPart",1,0],[0,"ParentPartName",1,0],[1,"PunchOrDieToEdit",0,"SelectBody",0],[0,"PunchPlateClearance",1,0],[0,"RenameComponent",1,0],[0,"ReverseDirection",1,0],[0,"SameWithPlate",1,0],[1,"SeedFace",0,"ScCollector",0],[1,"SelectFormingFaces",0,"ScCollector",0],[0,"StripperPlateClearance",1,0],[0,"TangentEdgeAngle",1,0],[0,"TraverseInteriorEdges",1,0],[0,"UseBottomBackPlateClearance",1,0],[0,"UseBottomPlateClearance",1,0],[0,"UseDiePlateClearance",1,0],[0,"UsePunchPlateClearance",1,0],[0,"UseSeedFacesAndBoundaryFaces",1,0],[0,"UseStripperPlateClearance",1,0]],[[["parentTag","origin"],"CreateNewComponent",{R_:{instance:"TaggedObject"}},2,0],[[],"ReverseTrimDirection",{},0,0],[[],"ExtractFormingRegion",{},0,0],[[],"DeletePunchOrDieComponent",{},0,0],[[],"CreateUserDefinedDatumPlane",{},0,0],[[],"AddInsertComponent",{},0,0]],[]];
SPLM.Tooling.FormingInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FormingInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FormingInsertBuilder.ParentTypes = Object.freeze({
    "Control" : "Control", "DieBase" : "DieBase", "SubDie" : "SubDie", "Die" : "Die"});

SPLM.Tooling.FormingInsertBuilder.BlankTypes = Object.freeze({
    "Standard" : "Standard", "UserDefined" : "UserDefined", "Edit" : "Edit", "Delete" : "Delete"});

SPLM.Tooling.FormingInsertBuilder.BlankPositions = Object.freeze({
    "PunchPlate" : "PunchPlate", "StripperPlate" : "StripperPlate", "DiePlate" : "DiePlate", "BottomBackingPlate" : "BottomBackingPlate", "TopPunchgPlate" : "TopPunchgPlate", "BottomPunchPlate" : "BottomPunchPlate"});

SPLM.Tooling.FormingInsertBuilder.DesignOptions = Object.freeze({
    "FormingPunch" : "FormingPunch", "FormingDie" : "FormingDie", "FormingAll" : "FormingAll"});

export default SPLM;